module.exports = __webpack_public_path__ + "img/ctrl-v-stub-up--i.24c44fae.svg";